import { Component, OnInit, EventEmitter } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { PackageService } from '../../common/package.service';

@Component({
  selector: 'activity-limit-form',
  templateUrl: './activity-limit-form.component.html',
  styleUrls: ['./activity-limit-form.component.css', '../../app.component.css'],
  providers: [PackageService],
})
export class ActivityLimitFormComponent implements OnInit {

 eventId: any;
 packageId: any;
 activityId: any;
 activityLimitForm: any;
 activityLimitId: any;
 activityLimit: any;
 activities: any;
 spinner: boolean = false;

 constructor(private formBuilder: FormBuilder, private packageService: PackageService, private activatedRoute: ActivatedRoute){
  this.activityLimitForm = this.formBuilder.group({
   'id': [''],
   'activityId': ['', Validators.required],
   'freeCount': ['', Validators.required],
  });
  this.activityLimit = this.activityLimitForm.value;
 }

 ngOnInit() {
 }

 onSave = new EventEmitter();

 saveActivityLimit() {
  if(this.activityLimitForm.valid)
  {
   this.spinner = true;
   var params = this.activityLimitForm.value;
   params.packageId = this.packageId;
   this.packageService.saveActivityLimit(params).subscribe(
    response => {
     this.spinner = false;
     if(response.status)
     this.onSave.emit();
    },
    error => {
     this.spinner = false;
    }
   );
  }
 }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/activity-limit-form/activity-limit-form.component.ts